import { render } from "./altaUsuarios.vue?vue&type=template&id=17fcb248"
import script from "./altaUsuarios.vue?vue&type=script&lang=js"
export * from "./altaUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__